<template>
  <div class="container">
    <div class="terms footerItem">
      <a
        href="https://www.pref.yamanashi.jp/dx/yamanashi_dataplatform_terms.html"
        target="_blank"
        rel="noopener noreferrer"
        >このサイトの利用について</a
      >
    </div>
    <div class="copyright">
      <p>Copyright © Yamanashi Prefecture.All Rights Reserved.</p>
    </div>
  </div>
</template>

<style scoped>
* {
  font-weight: 400;
  font-size: 0.9vw;
}

a:link,
a:link,
a:visited,
a:hover,
a:active {
  color: black;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
  text-decoration-thickness: 1.5px;
  text-underline-offset: 4px;
}

.container {
  width: 100%;
  height: 48px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: "terms copyright";
  align-self: center;
  background-color: #f0f1f2;
}

.footerItem {
  display: flex;
  justify-content: center;
  align-items: center;
}

.copyright {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
